<template>
  <div class="page" @keyup.delete="deleteKeyup()">
    <div class="main">
      <div class="login">请登录</div>
      <div class="ph-input">
        <div class="ph-text">+86</div>
        <van-field v-model="userPhone" type="tel" clear-trigger="always" class="ph-t" clearable placeholder="请输入您自己的电话卡进行绑定" />
      </div>
      <van-button class="bu_tn" round block type="info" :class="[userPhone?'bu_tn-a':'bu_tn']" native-type="submit" @click="onSubmit">获取验证码</van-button>
    </div>
    <div class="agree">
      <van-checkbox v-model="checked" />未注册的手机号登录时将自动注册并表示您同意
      <span @click="aaaa">《用户协议》</span>
      及
      <span @click="aaaa">《隐私权政策》</span>
    </div>
  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant'
export default {
  data() {
    return {
      userPhone: null,
      checked: true,
      loading: false
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    onSubmit() {
      if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.userPhone))) {
        Toast.fail('请填写正确的手机号')
        return
      }
      wxRequest('/bindPhone/sms/code', { userPhone: this.userPhone }, 'post').then(res => {
        if (res.data.code === '200') {
          localStorage.setItem('userPhone', this.userPhone)
          this.$router.replace('/newUser/phoneCode')
        } else {
          Toast.fail(res.data.message)
        }
      })
    },
    aaaa() {
      Dialog.confirm({
        title: '关于客户个人信息收集、使用规则的公告',
        width: '90%',
        showCancelButton: false,
        messageAlign: 'left',
        confirmButtonColor: '#ee0a24',
        message: `尊敬的客户：\n《全国人民代表大会常务委员会关于加强网络信息保护的决定》、《电信和互联网用户个人信息保护规定》（工业和信息化部令第24号）和《电话用户真实身份信息登记规定》（工业和信息化部令第25号）等国家法律法规的要求，客户在中国电信股份有限公司各类营业网点（含自有营业厅、手机营业厅、网上营业厅、授权合作代理商等）办理固定电话、移动电话（含无线上网卡）入网、过户以及需要出示客户证件的有关业务时，客户应配合出示有效证件原件并进行查验、登记，登记信息包括姓名、证件类型、号码及地址等。同时，为更好地提供服务，需要客户提供如联系人、联系电话、通信地址、电子邮箱等信息。客户本人持有效证件可通过自有营业厅查询和/或更正本人信息，或登录手机营业厅查询本人信息。如客户拒绝依法提供个人有效证件及真实信息，我公司有权不提供服务或终止服务。\n为向客户提供优质、个性化的服务，包括但不限于提供通信服务、保障通信服务安全、改善服务质量、推介个性化产品等，我公司将遵循合法、正当、必要的原则，按照法律法规规定和/或协议约定使用留存客户个人信息，并妥善保管，严格保密，依法保护客户个人信息，非因下列事由，不对外泄露客户个人信息：\n(a)事先获得客户的明确授权；\n(b)根据有关的法律法规要求；\n(c)按照相关司法机关和/或政府主管部门的要求；\n(d)为维护社会公众的利益所必需且适当；\n(e)为维护我公司或客户的合法权益所必需且适当。`
      }).then(() => {
        // on confirm
      }).catch(() => {
        // on cancel
      })
    }
  }
}
</script>
<style lang="less" scoped>
.page{
    background: #f7f8fa;
    display: flex;
    flex-direction: column;
    flex: 1;
    height:100%;
    .main{
        flex: 1;
        display: flex;
        align-items: stretch;
        flex-direction: column;
        .login{
            margin: 60px 0px 0px 24px;
            font-size: 28px;
            color: rgb(6, 18, 30);
            font-weight: bold;
        }
        .login-text{
            color: #707070;
            font-size: 16px;
            margin-left:24px;
            margin-top: 14px;
            line-height:20px;
            width:90%;
        }
        .captcha {
            display: flex;
            justify-content: center;
            margin-top: 40px;
        }
        input {
            margin-right: 20px;
            width: 45px;
            text-align: center;
            border: none;
            border-bottom: 1px solid #212121;
            font-size: 24px;
            outline: none;
            background: none;
        }
        input:last-of-type {
            margin-right: 0;
        }
        input:disabled {
            color: #000;
            background-color: #fff;
        }
        .point{
            flex-direction: row;
            margin-top: 37px;
            justify-content: center;
            display: flex;
            font-size: 17px;
            color: #707070;
            margin-bottom: 36px;
            .once{
                color:#0c62ee;
            }
        }

        .ph-input{
            margin: 40px 24px 20px;
            height: 60px;
            border-bottom: 1px solid #06121e;
            flex-direction: row;
            align-items: center;
            flex-grow: 0;
            display: flex;
            .ph-text{
                color: #06121e;
                width: 50px;
                line-height: 50px;
                height: 50px;
                font-size: 17px;
            }
            .ph-t{
                color: #06121e;
                flex: 1;
                line-height: 50px;
                height: 50px;
                font-size: 17px;
                padding: 0;
                background: none;
                ::v-deep.van-cell__value{
                    .van-field__control{
                        background: none;
                    }
                }
            }
        }
        .bu_tn{
            width: 230px;
            height: 50px;
            line-height: 50px;
            background: rgba(52,118,254,.1)!important;
            color: #3476fe;
            border: 0!important;
            border-radius: 94px;
            font-size: 16px;
            align-self: center;
            text-align: center;
        }
        .bu_tn-a{
            width: 230px;
            height: 50px;
            line-height: 50px;
            background: #3476fe!important;
            color: #fff;
            border: 0!important;
            border-radius: 94px;
            font-size: 16px;
            align-self: center;
            text-align: center;
        }
    }
    .agree{
        display: flex;
        width:300px;
        position:fixed;
        bottom:25px;
        flex-direction: row;
        justify-content: center;
        margin: auto;
        left:0;
        right: 0;
        text-align: center;
        line-height:20px;
        .van-checkbox{
            margin-right: 6px;
            width: 30px;
            ::v-deep .van-icon{
                width: 1em;
                height: 1em;
                line-height: 1;
            }
        }
        span{
            color:#0c62ee;
            display: contents;
        }
    }
}
</style>
